import { NgModule } from '@angular/core';
import { ZuperScrollbarDirective } from '@zuper/directives/scrollbar/scrollbar.directive';

@NgModule({
    declarations: [
        ZuperScrollbarDirective
    ],
    exports: [
        ZuperScrollbarDirective
    ]
})
export class ZuperScrollbarModule {
}
